/**
 * @generated SignedSource<<1869f36621461b2a9221745cb90491aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BaseReviewGrouptypeEnumType = "manager" | "peer" | "report" | "self";
export type ReviewCycleResponseFormQuery$variables = {
  reviewRequestEntityId: string;
  reviewCycleEntityId: string;
};
export type ReviewCycleResponseFormQueryVariables = ReviewCycleResponseFormQuery$variables;
export type ReviewCycleResponseFormQuery$data = {
  readonly viewer: {
    readonly findReviewCycle: {
      readonly id: string;
      readonly name: string;
      readonly allowPeersToRejectPeerReviewRequests: boolean;
    } | null;
    readonly findReviewRequest: {
      readonly id: string;
      readonly lockedForSubmission: boolean;
      readonly isRejected: boolean;
      readonly isSubmitted: boolean;
      readonly isClosed: boolean;
      readonly submittedAt: DateString | null;
      readonly closedAt: DateString | null;
      readonly reviewGroup: {
        readonly type: BaseReviewGrouptypeEnumType;
        readonly reviewTemplate: {
          readonly instructions: string | null;
        } | null;
      };
      readonly reviewee: {
        readonly user: {
          readonly name: string | null;
          readonly preferredName: string | null;
          readonly avatarUrl: string | null;
          readonly title: string | null;
          readonly viewerIsUser: boolean;
        } | null;
      };
      readonly reviewRequestQuestions: ReadonlyArray<{
        readonly id: string;
        readonly isPrivate: boolean;
        readonly description: string | null;
        readonly reviewResponse: {
          readonly content: any | null;
        } | null;
        readonly competency: {
          readonly " $fragmentSpreads": FragmentRefs<"CompetencyCard_competency">;
        } | null;
        readonly goal: {
          readonly " $fragmentSpreads": FragmentRefs<"GoalCard_goal">;
        } | null;
        readonly questionRevision: {
          readonly entityId: string;
          readonly body: string;
          readonly question: {
            readonly __typename: string;
            readonly entityId: string;
            readonly isOptional?: boolean;
            readonly shouldHideNumbers?: boolean;
            readonly maximumSelection?: number | null;
          };
          readonly scale?: ReadonlyArray<string>;
        };
        readonly " $fragmentSpreads": FragmentRefs<"ReviewCycleQuestionResponse_reviewRequestQuestion">;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"ReviewCycleIntro_reviewRequest">;
    } | null;
  } | null;
};
export type ReviewCycleResponseFormQueryResponse = ReviewCycleResponseFormQuery$data;
export type ReviewCycleResponseFormQuery = {
  variables: ReviewCycleResponseFormQueryVariables;
  response: ReviewCycleResponseFormQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reviewCycleEntityId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reviewRequestEntityId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "reviewCycleId",
      "variableName": "reviewCycleEntityId"
    }
  ],
  "concreteType": "ReviewCycle",
  "kind": "LinkedField",
  "name": "findReviewCycle",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowPeersToRejectPeerReviewRequests",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "reviewRequestId",
    "variableName": "reviewRequestEntityId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedForSubmission",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRejected",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSubmitted",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isClosed",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submittedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instructions",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsUser",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "scale",
    "storageKey": null
  }
],
v24 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "RatingQuestionRevision",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "RatingAndBodyQuestionRevision",
  "abstractKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOptional",
      "storageKey": null
    }
  ],
  "type": "ReviewCycleQuestionInterface",
  "abstractKey": "__isReviewCycleQuestionInterface"
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shouldHideNumbers",
  "storageKey": null
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "kind": "InlineFragment",
  "selections": (v29/*: any*/),
  "type": "RatingQuestion",
  "abstractKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maximumSelection",
  "storageKey": null
},
v32 = [
  (v31/*: any*/)
],
v33 = {
  "kind": "InlineFragment",
  "selections": (v32/*: any*/),
  "type": "MultipleSelectQuestion",
  "abstractKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBodyOptional",
  "storageKey": null
},
v35 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "choices",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReviewCycleResponseFormQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "ReviewRequest",
            "kind": "LinkedField",
            "name": "findReviewRequest",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReviewGroup",
                "kind": "LinkedField",
                "name": "reviewGroup",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReviewTemplate",
                    "kind": "LinkedField",
                    "name": "reviewTemplate",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Reviewee",
                "kind": "LinkedField",
                "name": "reviewee",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ModernReviewRequestQuestion",
                "kind": "LinkedField",
                "name": "reviewRequestQuestions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModernReviewResponse",
                    "kind": "LinkedField",
                    "name": "reviewResponse",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Competency",
                    "kind": "LinkedField",
                    "name": "competency",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "CompetencyCard_competency"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "goal",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "GoalCard_goal"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "questionRevision",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "questionRevisionV2",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "question",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v21/*: any*/),
                          (v27/*: any*/),
                          (v30/*: any*/),
                          (v33/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*: any*/),
                            "type": "RatingAndBodyQuestion",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v32/*: any*/),
                            "type": "MultipleSelectAndBodyQuestion",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReviewCycleQuestionResponse_reviewRequestQuestion"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReviewCycleIntro_reviewRequest"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReviewCycleResponseFormQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "ReviewRequest",
            "kind": "LinkedField",
            "name": "findReviewRequest",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReviewGroup",
                "kind": "LinkedField",
                "name": "reviewGroup",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReviewTemplate",
                    "kind": "LinkedField",
                    "name": "reviewTemplate",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Reviewee",
                "kind": "LinkedField",
                "name": "reviewee",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerIsPostReviewGiver",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReviewCycle",
                    "kind": "LinkedField",
                    "name": "reviewCycle",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "allowDraftResponsesDuringPeerSelection",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "launchEmailSentAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deliverableTypeManagerReviews",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deliverableTypeUpwardReviews",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deliverableTypePeerReviews",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "postReviewGiver",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ModernReviewRequestQuestion",
                "kind": "LinkedField",
                "name": "reviewRequestQuestions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModernReviewResponse",
                    "kind": "LinkedField",
                    "name": "reviewResponse",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Competency",
                    "kind": "LinkedField",
                    "name": "competency",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "goal",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "childrenList",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "private",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": "amountType",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "computedAmountType",
                        "storageKey": null
                      },
                      {
                        "alias": "goalAmount",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "computedGoalAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "progressAmount",
                        "storageKey": null
                      },
                      {
                        "alias": "startingAmount",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "computedStartingAmount",
                        "storageKey": null
                      },
                      {
                        "alias": "type",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "computedType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "computedProgressAmount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "questionRevision",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "questionRevisionV2",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "question",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v21/*: any*/),
                          (v27/*: any*/),
                          (v30/*: any*/),
                          (v33/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isRatingOptional",
                                "storageKey": null
                              },
                              (v34/*: any*/)
                            ],
                            "type": "RatingAndBodyQuestion",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isMultipleSelectOptional",
                                "storageKey": null
                              },
                              (v34/*: any*/)
                            ],
                            "type": "MultipleSelectAndBodyQuestion",
                            "abstractKey": null
                          },
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isMultipleChoiceOptional",
                                "storageKey": null
                              },
                              (v34/*: any*/)
                            ],
                            "type": "MultipleChoiceAndBodyQuestion",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v35/*: any*/),
                        "type": "MultipleSelectQuestionRevision",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v35/*: any*/),
                        "type": "MultipleChoiceQuestionRevision",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v35/*: any*/),
                        "type": "MultipleSelectAndBodyQuestionRevision",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v35/*: any*/),
                        "type": "MultipleChoiceAndBodyQuestionRevision",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPrivateQuestions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasOnlyPrivateQuestions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rejectedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "209b5a1ec73c882576176c07ccdb00b9",
    "id": null,
    "metadata": {},
    "name": "ReviewCycleResponseFormQuery",
    "operationKind": "query",
    "text": "query ReviewCycleResponseFormQuery(\n  $reviewRequestEntityId: String!\n  $reviewCycleEntityId: String!\n) {\n  viewer {\n    findReviewCycle(reviewCycleId: $reviewCycleEntityId) {\n      id\n      name\n      allowPeersToRejectPeerReviewRequests\n    }\n    findReviewRequest(reviewRequestId: $reviewRequestEntityId) {\n      id\n      lockedForSubmission\n      isRejected\n      isSubmitted\n      isClosed\n      submittedAt\n      closedAt\n      reviewGroup {\n        type\n        reviewTemplate {\n          instructions\n          id\n        }\n        id\n      }\n      reviewee {\n        user {\n          name\n          preferredName\n          avatarUrl\n          title\n          viewerIsUser\n          id\n        }\n        id\n      }\n      reviewRequestQuestions {\n        id\n        isPrivate\n        description\n        reviewResponse {\n          content\n          id\n        }\n        competency {\n          ...CompetencyCard_competency\n          id\n        }\n        goal {\n          ...GoalCard_goal\n          id\n        }\n        questionRevision: questionRevisionV2 {\n          __typename\n          entityId\n          body\n          ... on RatingQuestionRevision {\n            scale\n          }\n          ... on RatingAndBodyQuestionRevision {\n            scale\n          }\n          question {\n            __typename\n            entityId\n            ... on ReviewCycleQuestionInterface {\n              __isReviewCycleQuestionInterface: __typename\n              isOptional\n            }\n            ... on RatingQuestion {\n              shouldHideNumbers\n            }\n            ... on MultipleSelectQuestion {\n              maximumSelection\n            }\n            ... on RatingAndBodyQuestion {\n              shouldHideNumbers\n            }\n            ... on MultipleSelectAndBodyQuestion {\n              maximumSelection\n            }\n            id\n          }\n          id\n        }\n        ...ReviewCycleQuestionResponse_reviewRequestQuestion\n      }\n      ...ReviewCycleIntro_reviewRequest\n    }\n    id\n  }\n}\n\nfragment CompetencyCard_competency on Competency {\n  name\n  description\n}\n\nfragment GoalBadge_goal on Goal {\n  computedProgressAmount\n  entityId\n  id\n  state\n  status\n  type: computedType\n}\n\nfragment GoalCard_goal on Goal {\n  childrenList {\n    id\n  }\n  entityId\n  id\n  name\n  private\n  state\n  status\n  ...GoalProgress_goal\n  ...GoalBadge_goal\n}\n\nfragment GoalProgress_goal on Goal {\n  id\n  amountType: computedAmountType\n  goalAmount: computedGoalAmount\n  progressAmount\n  startingAmount: computedStartingAmount\n  type: computedType\n  computedProgressAmount\n}\n\nfragment ReviewCycleIntro_reviewRequest on ReviewRequest {\n  id\n  hasPrivateQuestions\n  hasOnlyPrivateQuestions\n  lockedForSubmission\n  reviewGroup {\n    type\n    id\n  }\n  isRejected\n  rejectedAt\n  reviewee {\n    viewerIsPostReviewGiver\n    reviewCycle {\n      allowDraftResponsesDuringPeerSelection\n      launchEmailSentAt\n      deliverableTypeManagerReviews\n      deliverableTypeUpwardReviews\n      deliverableTypePeerReviews\n      id\n    }\n    user {\n      preferredName\n      ...UserIntro_user\n      id\n    }\n    postReviewGiver {\n      preferredName\n      id\n    }\n    id\n  }\n}\n\nfragment ReviewCycleQuestionResponse_reviewRequestQuestion on ModernReviewRequestQuestion {\n  id\n  isPrivate\n  reviewResponse {\n    content\n    id\n  }\n  goal {\n    ...GoalCard_goal\n    id\n  }\n  questionRevision: questionRevisionV2 {\n    __typename\n    entityId\n    body\n    ... on RatingQuestionRevision {\n      scale\n    }\n    ... on MultipleSelectQuestionRevision {\n      choices\n    }\n    ... on MultipleChoiceQuestionRevision {\n      choices\n    }\n    ... on RatingAndBodyQuestionRevision {\n      scale\n    }\n    ... on MultipleSelectAndBodyQuestionRevision {\n      choices\n    }\n    ... on MultipleChoiceAndBodyQuestionRevision {\n      choices\n    }\n    question {\n      __typename\n      entityId\n      ... on ReviewCycleQuestionInterface {\n        __isReviewCycleQuestionInterface: __typename\n        isOptional\n      }\n      ... on RatingQuestion {\n        shouldHideNumbers\n      }\n      ... on MultipleSelectQuestion {\n        maximumSelection\n      }\n      ... on RatingAndBodyQuestion {\n        shouldHideNumbers\n        isRatingOptional\n        isBodyOptional\n      }\n      ... on MultipleSelectAndBodyQuestion {\n        maximumSelection\n        isMultipleSelectOptional\n        isBodyOptional\n      }\n      ... on MultipleChoiceAndBodyQuestion {\n        isMultipleChoiceOptional\n        isBodyOptional\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment UserIntro_user on User {\n  avatarUrl\n  title\n  name\n}\n"
  }
};
})();

(node as any).hash = "43b4070abc94320179f202f6438df59e";

export default node;
